module.exports = __webpack_public_path__ + "img/calendar-white.94c3c795.svg";